export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Proveedor\",\n    \"label_plural\": \"{{count}} proveedores\"\n}\n"